import Cookies from 'js-cookie'
import jwtDecode from 'jwt-decode'
import { getUnixTime } from 'date-fns'
import { fetchNewToken } from '@/models/auth'
import store from '../store'
import router from '../router'

const getDomain = () => {
  const env = process.env.VUE_APP_ENVIRONMENT
  const envMapper = {
    local: 'localhost',
    development: '.development.ine.com',
    staging: '.staging.ine.com',
    production: '.ine.com',
  }

  return envMapper[env] || '.ine.com'
}

const getAccessToken = () => {
  return Cookies.get('ine_access_token')
}

const getRefreshToken = () => {
  return Cookies.get('ine_refresh_token')
}

const cookieAttributes = {
  expires: 365,
  path: '/',
  domain: getDomain(),
  secure: false,
}

const setTokens = ({ Bearer: accessToken, Refresh: refreshToken }) => {
  Cookies.set('ine_access_token', accessToken, cookieAttributes)
  Cookies.set('ine_refresh_token', refreshToken, cookieAttributes)
}

const clearTokens = () => {
  store.commit('auth/IS_AUTHENTICATED_UPDATED', false)
  window.localStorage.removeItem('heldToken')
  window.localStorage.removeItem('heldRefreshToken')
  Cookies.remove('ine_access_token', cookieAttributes)
  Cookies.remove('ine_refresh_token', cookieAttributes)
}

const refreshToken = async originalRequest => {
  try {
    await fetchNewToken()
    const token = getAccessToken()
    originalRequest.headers.Authorization = `Bearer ${token}`
    return originalRequest
  } catch (error) {
    clearTokens()
    return error
  }
}

const checkToken = async config => {
  let request = {}
  const accessToken = getAccessToken()

  if (accessToken) {
    try {
      const { exp: expireTime } = jwtDecode(accessToken)
      const currentTime = getUnixTime(new Date()) + 600

      if (expireTime <= currentTime) {
        const refresh = await refreshToken(config)
        request = {
          ...refresh,
        }
      } else {
        request = {
          ...config,
          headers: {
            ...config.headers,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      }
    } catch (error) {
      clearTokens()
      router.push({
        name: 'login',
        query: {
          error: 'Your session has expired. Please login to continue.',
        },
      })
      throw error
    }
  } else {
    request = {
      ...config,
    }
  }

  return request
}

export {
  getAccessToken,
  setTokens,
  clearTokens,
  getRefreshToken,
  refreshToken,
  checkToken,
}
